import { createFileRoute } from "@tanstack/react-router";

import { Services } from "@/features/site/modules/services/services";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/$trainerSlug/services/")({
  component: ServicesPage,
  loader: () => ({ crumb: m.landing_nav_services() }),
});

function ServicesPage() {
  return <Services />;
}
